export const pendingSkuReasons = [
  {
    reason: "No picture",
    isSkuRequired: false,
  },
  {
    reason: "Exists but not chosen",
    isSkuRequired: true,
  },
  {
    reason: "New SKU created",
    isSkuRequired: true,
  },
  {
    reason: "Added new fitment data",
    isSkuRequired: true,
  },
  {
    reason: "Wrong code on item",
    isSkuRequired: false,
  },
  {
    reason: "No code on item",
    isSkuRequired: false,
  },
  {
    reason: "Wrong fitment/order",
    isSkuRequired: false,
  },
  {
    reason: "Not available",
    isSkuRequired: false,
  },
  {
    reason: "Exists and chosen",
    isSkuRequired: true,
  },
  {
    reason: "Different SKU",
    isSkuRequired: true,
  },
];
